<template>
  <gl-modal
    v-bind="$attrs"
    capitalize-title
    closable-top
    full-buttons
    submit-title="Contact Sales"
    title="Demo limit reached"
    to-end-buttons
    width="550"
    v-on="$listeners"
    @close="close"
    @submit="contactSupport"
  >
    <div class="fs-14 mb-3">
      You have used all available requests. Contact Sales to continue.
    </div>
  </gl-modal>
</template>

<script>
// Components
import GlModal from '@/components/gl-modal'

// Vuex
import { mapMutations } from 'vuex'

export default {
  components: {
    GlModal,
  },
  inheritAttrs: false,
  data() {
    return {
      email: '',
    }
  },
  methods: {
    ...mapMutations({
      SET_REQUESTS_ATTENTION_MODAL: 'user/SET_REQUESTS_ATTENTION_MODAL',
    }),
    close() {
      this.SET_REQUESTS_ATTENTION_MODAL(false)
    },
    contactSupport() {
      window.location.href = 'mailto:support@glprotocol.com'
    },
  },
}
</script>
